<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('profile.printingsurface.printingsurfaces')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <PrintingSurfaceForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import PrintingSurfaceForm from '../../components/printingsurface/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'PrintingSurface';

const { mapFields } = createHelpers({
  getterType: 'printingsurface/getField',
  mutationType: 'printingsurface/updateField'
});

export default {
  name: 'PrintingSurfaceCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    PrintingSurfaceForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('printingsurface', ['create', 'reset'])
  }
};
</script>
